<app-header />

<main class="container-fluid mt-3">
  <router-outlet></router-outlet>
</main>

<app-footer />
